import { render, staticRenderFns } from "./LicenseType.vue?vue&type=template&id=0c112856&"
import script from "./LicenseType.vue?vue&type=script&lang=js&"
export * from "./LicenseType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports